
import {
  APPLY_CLIENT_SIGNATURE,
  } from '../actions/types';
  
  const initialState = {
    
  };
  
  export const ApplyClientSignatureReducer = (state = initialState, action: any) => {
    const oldState = { ...state };
    const { type, payload } = action;
    switch (action.type) {
      case APPLY_CLIENT_SIGNATURE:
        return {
          ...state,
          signedDoc: payload,
        };

      default:
        return { ...state };
    }
  };
  